<template>
  <fragment>
    <div
      v-for="aState in stateSubset"
      :key="aState.id"
      :class="layoutClasses"
      class="patient-states"
      :data-testid="`${aState.id}-container`"
    >
      <state-input
        :state="aState"
        :initial-value="getStateValue(aState.id)"
        :disabled="readonly"
        :language="caseConf.language"
        :use-default="true"
        :use-radio-buttons="useRadioButtons"
        :is-absolute="true"
        @input="value => setStateValue(aState.id, value)"
      />
      <slot />
    </div>
  </fragment>
</template>

<script>
import { assign, get, set, debounce } from 'lodash';
import StateInput from '~lib/common/components/StateInput.vue';

export default {
  name: 'patient-states',
  components: {
    StateInput,
  },
  props: {
    states: {
      type: Array,
      default: () => [],   
    },
    caseConf: {
      type: Object,
      default: () => ({
        language: 'en',
      }),
    },
    category: {
      type: String,
      default: undefined,
    },
    stateIds: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    isNewCase: {
      type: Boolean,
      default: false,
    },
    useRadioButtons: {
      type: Boolean,
      default: false,
    },
    noLayout: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      state: {
        caseConf: null,
      },
    };
  },
  computed: {
    defaults() {
      return {
        _initialStates: this.stateSubset.map(state => ({
          id: state.id,
          options: {
            id: this.getStateOptionId(state.id, this.caseConf),
            value: this.getStateValue(state.id, this.caseConf),
          },
        })),
      };
    },
    stateSubset() {
      if (this.category) {
        return this.states.filter(s => !this.category || s.category === this.category);      
      } else if (this.stateIds) {        
        return this.stateIds.map(id => {
          return this.states.find(s => s.id === id);
        });
      }
      return [];
    },
    layoutClasses() {
      if (this.useRadioButtons) {
        return 'radio-state-container';
      } else if (this.noLayout) {
        return '';
      }
      return 'state-container md-layout-item md-small-size-50 md-large-size-33 md-xlarge-size-25';
    }
  },
  created() {
    this.state.caseConf = assign(this.state.caseConf, this.defaults);
    this.emitUpdate = debounce(this.emitUpdate);
  },
  methods: {
    updateCase(key, value) {
      set(this.state.caseConf, key, value);
      this.emitUpdate();
    },
    getStateValue(stateId, caseConf = this.state.caseConf) {
      if (!caseConf || !caseConf._initialStates) {
        return undefined;
      }
      return get(
        caseConf._initialStates.find(s => s.id === stateId),
        'options.value',
      );
    },
    getStateOptionId(stateId, caseConf = this.state.caseConf) {
      if (!caseConf || !caseConf._initialStates) {
        return undefined;
      }
      return get(
        caseConf._initialStates.find(s => s.id === stateId),
        'options.id',
      );
    },
    setStateValue(stateId, value) {
      set(
        this.state.caseConf._initialStates.find(s => s.id === stateId),
        'options.value',
        value,
      );
      this.emitUpdate();
    },
    emitUpdate() {
      this.$emit('update', this.state.caseConf);
    },
  },
};
</script>

<style scoped>
.patient-states {
  position: relative;
}
.state-container {
  margin-top: 10px;
  margin-bottom: 10px;
}
.radio-state-container {
  max-width: 100%;
}
</style>
